"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermafrostVortexAbilityHandler = exports.PermafrostVortexActorAbilityFactory = exports.PermafrostVortexAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Slow_1 = require("../../core/effects/core/Slow");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const Random_1 = require("../../utils/Random");
class PermafrostVortexAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.PermafrostVortex;
        this.__typeName = "PermafrostVortex";
    }
}
exports.PermafrostVortexAbilityArgs = PermafrostVortexAbilityArgs;
let PermafrostVortexActorAbilityFactory = class PermafrostVortexActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("PermafrostVortex", "AllEnemies", 3);
    }
};
PermafrostVortexActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("PermafrostVortex")
], PermafrostVortexActorAbilityFactory);
exports.PermafrostVortexActorAbilityFactory = PermafrostVortexActorAbilityFactory;
let PermafrostVortexAbilityHandler = class PermafrostVortexAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const enemies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        container.applyMultiAttack({
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            sequence,
            targets: enemies.map(targetId => ({
                targetId,
                jitter: (0, Random_1.random)(5, 25),
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Frost", 80)
                ],
                effects: [
                    { targetId, duration: Duration_1.Duration.Turns(4), effect: new Slow_1.SlowEffectArgs(1) }
                ]
            })),
            onHit: (sequence, target) => {
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(target.targetId, "feet"), "PermafrostShower"));
            },
            onMiss: (sequence, target) => {
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(target.targetId, "feet", "behind"), "PermafrostShower"));
            },
        });
    }
};
PermafrostVortexAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.PermafrostVortex)
], PermafrostVortexAbilityHandler);
exports.PermafrostVortexAbilityHandler = PermafrostVortexAbilityHandler;
